import DesShareLibraryToUsersViewModel from 'viewmodel/DesShareLibraryToUsersViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesShareLibraryToUsers extends DesBaseCatalogAcc {
    constructor() {
        super(DesShareLibraryToUsersViewModel);
    }

    get libraryId() {
        return this.getAttribute('library-id') || this.getAttribute('libraryid');
    }

    get emailTemplateId() {
        return this.getAttribute('email-template-id') || this.getAttribute('emailtemplateid');
    }

    get emailTemplateParams() {
        return this.getAttribute('email-template-params') || this.getAttribute('emailtemplateparams');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryid: this.libraryId,
            emailtemplateparams: this.emailTemplateParams,
            emailtemplateid: this.emailTemplateId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'library-id', 'libraryid',
            'email-template-id', 'emailtemplateid',
            'email-template-params', 'emailtemplateparams'];
    }
}

if (!window.customElements.get('des-share-library-to-users')) {
    window.customElements.define('des-share-library-to-users', DesShareLibraryToUsers);
}
